import { MicrosoftOAuthPage } from '@features/auth/components/MicrosoftOAuthPage';
import { OAuthCallbackSearchSchema } from '@routes/searchSchemas';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/microsoftoauth')({
  validateSearch: OAuthCallbackSearchSchema,
  component: MicrosoftOAuthPage,
});
